





































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { size, cloneDeep, includes } from 'lodash';

import ZenButton from '@reciprocity/button';
import { BForm, BFormGroup, BFormInput, BFormTextarea, VBTooltip, BDropdown, BDropdownItem } from 'bootstrap-vue';
import { dateDisplay } from '@/utils';
import { SamlSettings } from '@/pages/settings/authentication/types';

export default Vue.extend({
  name: 'IdpSettings',
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    ZenButton,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    samlSettings: {
      type: Object as () => SamlSettings,
      default: {},
      required: true,
    },
  },
  data() {
    return {
      editCertNumber: <Number>-1,
      idpCerts: cloneDeep(this.samlSettings.idpCerts),
      idpCertEdited: [false, false],
      idpEntityIdEdited: false,
      idpSsoUrlEdited: false,
      idpSloUrlEdited: false,
      updateCerts: <Number>0,
    };
  },
  computed: {
    idpEntityIdValid() {
      return this.idpEntityIdEdited && !this.samlSettings.idpEntityId ? false : null;
    },
    idpEntityId: {
      get() {
        return this.samlSettings.idpEntityId;
      },
      set(idpEntityId) {
        this.$emit('update-saml-settings', { ...this.samlSettings, idpEntityId }, !!idpEntityId);
      },
    },
    idpSsoUrlValid() {
      return this.idpSsoUrlEdited && !this.samlSettings.idpSsoUrl ? false : null;
    },
    idpSsoUrl: {
      get() {
        return this.samlSettings.idpSsoUrl;
      },
      set(idpSsoUrl) {
        this.$emit('update-saml-settings', { ...this.samlSettings, idpSsoUrl }, !!idpSsoUrl);
      },
    },
    idpSloUrlValid() {
      return this.idpSloUrlEdited && !this.samlSettings.idpSloUrl ? false : null;
    },
    idpSloUrl: {
      get() {
        return this.samlSettings.idpSloUrl;
      },
      set(idpSloUrl) {
        this.$emit('update-saml-settings', { ...this.samlSettings, idpSloUrl }, !!idpSloUrl);
      },
    },
    idpCertSize() {
      return size(this.samlSettings.idpCerts);
    },
  },
  watch: {
    samlSettings() {
      this.idpCerts = cloneDeep(this.samlSettings.idpCerts);
    },
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    removeCert(index: number) {
      this.idpCerts.splice(index, 1);
      this.$emit('update-saml-settings', { ...this.samlSettings, idpCerts: this.idpCerts });
    },
    addCert() {
      this.idpCerts.push({
        datetime: new Date().toISOString(),
        value: '',
      });
      this.editCertNumber = size(this.idpCerts) - 1;
    },
    idpCertValid(index: number) {
      return !(this.idpCertEdited[index] && !this.idpCerts[index].value);
    },
    saveCert(index: number) {
      this.idpCertEdited[index] = true;
      if (this.idpCertValid(index)) {
        this.$emit('update-saml-settings', { ...this.samlSettings, idpCerts: this.idpCerts });
        this.editCertNumber = -1;
      } else {
        this.updateCerts++;
      }
    },
    cancelCert() {
      this.idpCerts = cloneDeep(this.samlSettings.idpCerts);
      this.editCertNumber = -1;
      this.idpCertEdited = [false, false];
    },
    dateDisplay,
    includes,
  },
});
